var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4FEE\\u6539\\u5B9A\\u7A3F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875\\u5B9A\\u7A3F",
    transform: "translate(-1858, -4250)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28",
    transform: "translate(1844, 4169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(14, 81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12.48 C24,9.12 20.76,6.48 16.8,6.48 C12.84,6.48 9.6,9.12 9.6,12.48 C9.6,15.84 12.84,18.48 16.8,18.48 C17.52,18.48 18.24,18.36 18.96,18.24 L21.24,19.44 L20.64,17.64 C22.68,16.44 24,14.64 24,12.48 L24,12.48 Z M14.28,11.52 C13.56,11.52 13.08,11.04 13.08,10.32 C13.08,9.6 13.56,9.12 14.28,9.12 C15,9.12 15.48,9.6 15.48,10.32 C15.48,10.92 14.88,11.52 14.28,11.52 Z M19.2,11.52 C18.48,11.52 18,11.04 18,10.32 C18,9.6 18.48,9.12 19.2,9.12 C19.92,9.12 20.4,9.6 20.4,10.32 C20.4,10.92 19.8,11.52 19.2,11.52 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,12.24 C8.4,8.52 12,5.52 16.56,5.52 L16.92,5.52 C15.96,2.4 12.72,0 8.64,0 C3.84,0 0,3.24 0,7.2 C0,9.72 1.56,12 3.96,13.2 L3.24,15.36 L6,14.04 C6.84,14.28 7.68,14.4 8.64,14.4 L8.88,14.4 C8.52,13.68 8.4,12.96 8.4,12.24 L8.4,12.24 Z M11.64,2.52 C12.48,2.52 13.2,3.24 13.2,4.08 C13.2,4.92 12.48,5.64 11.64,5.64 C10.8,5.52 10.08,4.8 10.08,3.96 C10.08,3.12 10.8,2.52 11.64,2.52 L11.64,2.52 Z M5.76,5.52 C4.92,5.52 4.32,4.8 4.32,3.96 C4.32,3.12 5.04,2.4 5.88,2.4 C6.72,2.4 7.32,3.12 7.32,3.96 C7.32,4.8 6.6,5.52 5.76,5.52 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWei);
export default __webpack_public_path__ + "static/media/icon_wei.192932f4a43397e58888bca79f328e71.svg";
export { ForwardRef as ReactComponent };